/*
 * @Author: Wang Wenmao
 * @Date: 2023-12-07 10:05:41
 * @LastEditors: Wang Wenmao
 * @LastEditTime: 2024-01-11 14:10:31
 * @Description: 积分兑换
 */
import React, { Component } from 'react';
import { Form, Row, Col, Checkbox, Slider, Tooltip, Icon } from 'antd';
import { ColorPicker } from '../../tools';
import { ShowProducts } from './show-products';
import { ShowCoupons } from './show-coupons';
import { UploadImg } from './upload-img';
import DetailTitle from '../../DetailTitle';
import { FormItemLayout, ConfigFormDecorator } from '../../tools';

const FormItem = Form.Item;

const tabImgs = [
    {
        label: '选中tab图',
        k: 'activeTabImage',
        tip: '建议尺寸:363x63',
    },
    {
        label: '未选中tab图',
        k: 'inactiveTabImage',
        tip: '建议尺寸:363x63',
    },
];

const bgImg = [
    {
        label: '背景图片',
        k: 'bgPic',
        tip: '建议尺寸:726x726',
    },
];

/**
 * 商品列表组件-配置信息
 *  */
class Index extends Component<any> {
    handleChangeItem = (item: any) => {
        const { onChange, value } = this.props;
        let newData = JSON.parse(JSON.stringify(value));
        newData = { ...newData, ...item };
        onChange(newData);
    };

    /**
     * @description 渲染图片上传组件
     * @param key productTab couponTab
     * @param list tabImgs bgImg
     * @returns {JSX.Element}
     */
    renderImage = (key: string, list: any[]): JSX.Element => {
        const {
            value,
            form: { getFieldDecorator },
        } = this.props;
        key = key ? `${key}_` : key;

        return (
            <div>
                {list.map((item) => {
                    const initialValue = value[`${key}${item.k}`];
                    return (
                        <FormItem {...FormItemLayout} label={item.label} key={`${key}${item.k}`}>
                            {getFieldDecorator(`${key}${item.k}`, {
                                rules: [{ required: !!key, message: `请上传${item.label}` }],
                            })(
                                <UploadImg
                                    {...this.props}
                                    value={initialValue}
                                    tip={item.tip}
                                    onChangeItem={(path) =>
                                        this.handleChangeItem({ [`${key}${item.k}`]: path })
                                    }
                                />
                            )}
                        </FormItem>
                    );
                })}
            </div>
        );
    };

    /**
     * @description 渲染商品列表/优惠券组件
     * @param key productTab couponTab
     * @param name 积分商品 兑换优惠券
     * @param selector 商品列表
     * @returns  {JSX.Element}
     */
    renderList = (key: string, name: string, selector?: any): JSX.Element => {
        const {
            onChange,
            form: { getFieldDecorator },
        } = this.props;
        const keys = { productTab: 'productTab_pointsProduct', couponTab: 'couponTab_coupons' };
        return (
            <FormItem
                {...FormItemLayout}
                label={
                    <span>
                        <Tooltip title="可拖动右侧商品调整排列顺序">
                            <Icon type="question-circle-o" />
                        </Tooltip>
                        &nbsp; {name}
                    </span>
                }
            >
                {getFieldDecorator(keys[key], {
                    rules: [{ required: true, message: `请添加${name}` }],
                })(
                    key === 'productTab' ? (
                        <ShowProducts selector={selector} />
                    ) : (
                        <ShowCoupons onChange={onChange} />
                    )
                )}
            </FormItem>
        );
    };

    // 渲染背景设置模块
    renderBgSetting = () => {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <DetailTitle label="背景设置" />
                {this.renderImage('', bgImg)}
                <FormItem {...FormItemLayout} label="页面边距">
                    {getFieldDecorator('pageMargin')(<Slider max={40} min={0} />)}
                </FormItem>
                <FormItem {...FormItemLayout} label="背景圆角">
                    {getFieldDecorator('bgRoundedCorners')(<Slider max={100} min={0} />)}
                </FormItem>
            </div>
        );
    };

    // 渲染兑换商品tab
    renderProductTab = () => {
        const {
            selector,
            value: { productTab_color },
            form: { getFieldDecorator },
        } = this.props;

        return (
            <div>
                <DetailTitle label="兑换商品tab" />
                {this.renderImage('productTab', tabImgs)}
                {this.renderList('productTab', '积分商品', selector)}
                <FormItem {...FormItemLayout} label="显示内容">
                    {getFieldDecorator('productTab_showData')(
                        <Checkbox.Group style={{ width: '100%', marginTop: '8px' }}>
                            <Row>
                                <Col span={24}>
                                    <Checkbox value="name">商品名称</Checkbox>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ display: 'flex', alignItems: 'center' }}>
                                    <Checkbox value="price">积分价格</Checkbox>
                                    <ColorPicker
                                        value={productTab_color}
                                        onChange={(color) =>
                                            this.handleChangeItem({ productTab_color: color })
                                        }
                                    />
                                </Col>
                            </Row>
                        </Checkbox.Group>
                    )}
                </FormItem>
            </div>
        );
    };

    // 渲染兑换优惠券tab
    renderCouponTab = () => {
        return (
            <div>
                <DetailTitle label="兑换优惠券tab" />
                {this.renderImage('couponTab', tabImgs)}
                {this.renderList('couponTab', '优惠券')}
            </div>
        );
    };

    render() {
        console.log(
            '%c this.props',
            'font-size:36px;color: #00b33c;background:pink;',
            this.props.value
        );

        return (
            <div style={{ height: '600px', overflow: 'auto' }}>
                <Form className="point-swap">
                    {this.renderBgSetting()}
                    {this.renderProductTab()}
                    {this.renderCouponTab()}
                </Form>
            </div>
        );
    }
}

export const PointSwap = ConfigFormDecorator(Index);
